import { Component, Inject, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CaseView } from '../../../models/caseview.model';
import { TranslateService } from '@ngx-translate/core';
import { forkJoin, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

export class customData {
  selectedData: CaseView[];
  isFromCustomAction: boolean;
}

@Component({
  selector: 'dg-recall',
  templateUrl: './dg-recall.component.html',
  styleUrls: ['./dg-recall.component.scss'],
})
export class DgRecallComponent implements OnInit {
  message: any;
  docId: any;
  jobId: any;
  constructor(
    private http: HttpClient,
    @Inject(MAT_DIALOG_DATA) public data: customData,
    private dialogRef: MatDialogRef<DgRecallComponent>,
    public translate: TranslateService
  ) {}

  ngOnInit(): void {}

  onRecall(): void {
    const caseDataArray = this.data?.selectedData;
    const apiList = [];
    caseDataArray.forEach((data) => {
      const dataForPost = {
        recId: data.docId,
        appTypeId: data.appTypeId == '3' ? 3 : 1,
        jobId: data.jobId,
      };
      const api = this.http
        .post('/workflow/recall-outbox-case', dataForPost)
        .pipe(
          map((r) => !!r),
          catchError((e) => of(false))
        );
      apiList.push(api);
    });
    forkJoin(apiList).subscribe((resArr: boolean[]) => {
      const anySuccess = resArr.some((r) => !!r);

      this.dialogRef.close(anySuccess);
    });
  }
}
